import React from 'react';
import { useSelector } from 'react-redux';
import Counter from '../../../shared/components/Counter';

const MedicationListSectionCounter = () => {
  const current = useSelector(
    (state) => state.records.current?.record?.medications || {},
  );
  const no_medications = useSelector(
    (state) => state.records.current?.record?.no_medications,
  );

  return <Counter value={no_medications ? 1 : Object.keys(current).length} />;
};

export default MedicationListSectionCounter;
